import css from '../../css/article.pcss.json'

const resize = (mediaContent: HTMLElement, caption: HTMLElement) => {
  caption.style.width = 'max-content'
  window.getComputedStyle(caption).width
  const mediaContentWidth = mediaContent.offsetWidth
  const captionWidth = caption.offsetWidth
  caption.style.width = '100%'
  const contentWidth = Math.min(700, mediaContent.closest('[data-plugins*="caption-autosize"]').clientWidth)
  if (mediaContentWidth >= contentWidth // Медиа шире контентной области
    || captionWidth >= mediaContentWidth) { // Подпись шире медиа
    return
  }
  caption.style.width = `${mediaContentWidth}px`
}

// noinspection JSUnusedGlobalSymbols
export default (elements: NodeListOf<HTMLElement>) => {
  elements.forEach(element => {
    const caption = element.querySelector<HTMLElement>(`.${css['caption']}`)
    const mediaContent = element.querySelector<HTMLElement>(`[data-media-content]`)
    if (caption && mediaContent) {
      resize(mediaContent, caption)
      const observer = new ResizeObserver(() => {
        resize(mediaContent, caption)
      })
      observer.observe(mediaContent)
    }
  })
}
